import React from "react";

function No() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 128 128"
    >
      <circle
        cx="64.12"
        cy="64"
        r="45"
        fill="#ee404c"
        data-original="#ee404c"
      ></circle>
      <path
        fill="#fff7ed"
        d="M46.1 81.9a5 5 0 007.12 0L64 71.12 74.78 81.9a5 5 0 007.12-7.12L71.12 64 81.9 53.22a5 5 0 10-7.12-7.12L64 56.88 53.22 46.1a5 5 0 10-7.12 7.12L56.88 64 46.1 74.78a5 5 0 000 7.12z"
        data-original="#fff7ed"
      ></path>
    </svg>
  );
}

export default No;
